import { fetcher } from '#lib/backendFetcher';

/**
 * Resolves a free-text location (city / postal code) to coordinates for the
 * search popup's radius map. Uses the same geocoder as the actual search.
 *
 * @param {Object} params
 * @param {string} params.location - City or postal code
 * @param {string} [params.country] - Country name (biases the lookup)
 * @returns {Promise<{lat: number|null, lng: number|null, found?: boolean}>}
 */
export const geocodeLocation = async ({ location, country }) => {
	return await fetcher('/api/v1/search/location/geocode', {
		method: 'POST',
		body: { location, country },
	});
};
